var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-layout" },
    [
      _vm.gridApi
        ? _c("search-filter-manager", {
            attrs: {
              "grid-api": _vm.gridApi,
              "grid-url": "/api/processcharges/shipment/grid/saved",
              "refresh-server-side": _vm.refreshServerSide,
              "show-search-bar": false,
            },
            on: { "filter-loaded": _vm.filterHasLoaded },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c("bulk-actions", {
            attrs: {
              "selected-jobs": _vm.selectedRows,
              "trigger-bulk-recalculate": _vm.triggerBulkRecalculate,
              type: "shipment",
            },
          }),
          _c("ag-grid-vue", {
            staticClass: "grid-display",
            class: _vm.gridThemeClass,
            attrs: {
              "row-model-type": "serverSide",
              "column-defs": _vm.columnDefs,
              "default-col-def": _vm.defaultColDef,
              "grid-options": _vm.gridOptions,
              "suppress-excel-export": false,
              "row-selection": _vm.rowSelection,
              "side-bar": _vm.gridSideBar,
            },
            on: {
              "grid-ready": _vm.onGridReady,
              "selection-changed": _vm.onSelectionChanged,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }